import React from "react";
import {useState} from "react";
import "./Searchbar.css";

import {Card, Col, Row} from "react-bootstrap";
import ModalSelectPort from "./ModalSelectPort";
import SearchbarMenu from "./SearchbarMenu";
import SearchbarSingleRoute from "./SearchbarSingleRoute";

const Searchbar = (props) => {
  const [startLocation, setStartLocation] = useState("");
  const [destinationLocation, setDestinationLocation] = useState("");
  const [targetElement, setTargetElement] = React.useState(null);
  const [activeTab, setActiveTab] = useState("single");

  const handleItemClick = (event) => {
    setTargetElement(event.currentTarget); // Speichere das geklickte Element
  };

  const handleSearch = () => {
    console.log("Suche von:", startLocation, "nach:", destinationLocation);
    // Hier wird später die Routensuche implementiert
  };

  const swapLocations = () => {
    const temp = startLocation;
    setStartLocation(destinationLocation);
    setDestinationLocation(temp);
  };

  const handleTabSelect = (eventKey) => {
    setActiveTab(eventKey);
  };

  const isRoundTrip = activeTab === "roundtrip";

  return (
    <>
      <div className="search-container">
        <Card className="search-card">
          <Card.Body>
            <Row className="searchbar-menu-row">
              <Col className="searchbar-menu-row">
                <SearchbarMenu
                  activeKey={activeTab}
                  onSelect={handleTabSelect}
                />
                <ModalSelectPort
                  show={props.showModalSelectPort}
                  handleSelectPort={props.handleSelectPort}
                  handleCloseModalSelectPort={props.handleCloseModalSelectPort}
                  targetElement={targetElement}
                  isSelectingDestination={props.isSelectingDestination}
                  selectedPortofLoading={props.selectedPortofLoading}
                />
              </Col>
            </Row>
            <Row className="searchbar-single-route-row">
              <Col>
                <SearchbarSingleRoute
                  {...props}
                  isRoundTrip={isRoundTrip}
                  selectedPortofLoading={props.selectedPortofLoading}
                  handleSelectPort={props.handleSelectPort}
                  handleShowModalSelectPort={props.handleShowModalSelectPort}
                  selectedPortofDischarge={props.selectedPortofDischarge}
                  handleItemClick={handleItemClick}
                />
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </div>
    </>
  );
};

export default Searchbar;
